import {createRoot} from 'react-dom/client'
import axios from 'axios'
import {QueryClient, QueryClientProvider} from 'react-query'
import 'bootstrap/dist/css/bootstrap.min.css'
import './styles/globals.css'
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import {ApiClientProvider} from './app/modules/api/ApiClientProvider'
import {apiClient} from './app/modules/api/apiClient'
import {ThemeProvider} from './app/theme/ThemeProvider'
import {installBlazorBridge} from './app/interop/blazorBridge'
import {installBootstrapInterop} from './app/interop/bootstrapInterop'
import {registerPeriodicCouponsStrategyWidgets} from './app/modules/strategies/PeriodicCouponsStrategyWidget'
import {registerPeriodicDividendsStrategyWidgets} from './app/modules/strategies/PeriodicDividendsStrategyWidget'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

setupAxios(axios)
installBlazorBridge()
installBootstrapInterop()
registerPeriodicCouponsStrategyWidgets()
registerPeriodicDividendsStrategyWidgets()

const queryClient = new QueryClient()
const container = document.getElementById('root')
const baseUrl = document.querySelector('base')?.getAttribute('href') ?? '/'

if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <AuthProvider>
          <ApiClientProvider client={apiClient}>
            <AppRoutes baseUrl={baseUrl} />
          </ApiClientProvider>
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )

  window.setTimeout(() => {
    document.getElementById('splash-screen')?.remove()
    document.getElementById('layout-styles-anchor')?.remove()
  }, 0)
}

serviceWorkerRegistration.unregister()
reportWebVitals()
